import './index.css';

export default {
  name: 'Adialog',
  props: {
    id: { type: String, default: () => (`a-dialog-${Math.random().toString().substring(2)}`) },
    wide: { type: Boolean, default: () => false },
    check: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    lockScroll: { type: Boolean, default: () => true },
    destroyOnClose: { type: Boolean, default: () => false },
    closeOnClickModal: { type: Boolean, default: () => false },
    visible: { type: Boolean, default: () => false },
    finishText: { type: String, default: () => '保存' },
    submitText: { type: String, default: () => '确定' },
    rejectText: { type: String, default: () => '驳回' },
    cancelText: { type: String, default: () => '取消' },
  },
  data() {
    return {
      key: `${this.visible}-${Math.random()}`,
    }
  },
  watch: {
    visible(status = false) {
      if (status == true) this.key = `${status}-${Math.random()}`;
    }
  },
  methods: {
    format() {
      if (this.check == false) return true;
      let data = [];
      let pass = true;
      let elements = this.$slots.default;
      (function recursion(node = []) {
        if (node.length > 0) node.forEach(a => {
          if (a && a.componentInstance) {
            let item = a.componentInstance;
            if (item.$children && item.$children.length && item.$children.length > 0) recursion(item.$children);
            if (item.result && item.result()) data.push(item.result());
            if (item.verify && !item.verify()) pass = false;
          } else {
            if ((a.result) && a.result()) data.push(a.result());
            if ((a.verify) && !a.verify()) pass = false;
          }
        });
      })(elements);
      if (pass == false) return false;
      let params = data.length && data.length > 0 ? (data.length && data.length > 1 ? data : data[0]) : null;
      return params;
    },
    finish(e) {
      e.preventDefault();
      if (this.format()) this.$emit('finish', this.format());
    },
    submit(e) {
      e.preventDefault();
      if (this.format()) this.$emit('submit', this.format());
    },
    reject(e) {
      e.preventDefault();
      this.$emit('reject', this.format());
    },
    cancel(e) {
      e.preventDefault();
      this.$emit('cancel', this.format());
    },
  },
  render() {
    const {
      top = '10vh',
      title = '编辑',
      width = this.wide ? '1200px' : '600px',
      padding = '16px',
      height = 'auto',
      maxHeight = '68vh',
      styles = {},
      action = [],
      ...attrs
    } = this.$attrs;
    const { close = null, finish = null, submit = null, reject = null, cancel = null } = this.$listeners;
    return (
      <div id={this.id} class="a-dialog" v-loading={this.loading}>
        <el-dialog
          top={top}
          title={title}
          width={width}
          visible={this.visible}
          lock-scroll={this.lockScroll}
          destroy-on-close={this.destroyOnClose}
          close-on-click-modal={this.closeOnClickModal}
          on-close={close ? () => close() : (cancel ? () => cancel() : (submit ? () => submit() : (() => false)))}
          {...{ attrs }}
        >
          {this.$slots.header}
          <div class="a-dialog-body" key={this.key} style={{ padding, height, maxHeight, ...styles }}>
            {this.$slots.default}
          </div>
          <div class={['a-dialog-foot', ((finish || submit || reject || cancel || action.length > 0) ? null : 'custom')]}>
            {(finish || submit || cancel || reject || action.length > 0) && (
              <div>
                {finish && <el-button disabled={this.loading} loading={this.loading} on-click={(a) => this.finish(a)} type="success">{this.finishText}</el-button>}
                {submit && <el-button disabled={this.loading} loading={this.loading} on-click={(a) => this.submit(a)} type="primary">{this.submitText}</el-button>}
                {reject && <el-button disabled={this.loading} loading={this.loading} on-click={(a) => this.reject(a)} type="danger">{this.rejectText}</el-button>}
                {cancel && <el-button disabled={this.loading} on-click={(a) => this.cancel(a)}>{this.cancelText}</el-button>}
                {action.map((a, b) => (
                  <el-button key={b} disabled={this.loading} on-click={(e) => a.click(this.format(), e)} {...{ attrs: a }}>
                    {a.label || a.title || a.text || ''}
                  </el-button>
                ))}
              </div>
            )}
          </div>
          {this.$slots.footer}
        </el-dialog>
      </div>
    );
  }
}